(() => {
  const catalogStateKey = "fastplus.catalog.state";
  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const supportsViewTransitions = typeof document.startViewTransition === "function" && !prefersReducedMotion;

  function readJson(key) {
    try {
      const raw = window.sessionStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }

  function writeJson(key, value) {
    try {
      window.sessionStorage.setItem(key, JSON.stringify(value));
    } catch {}
  }

  function relativeUrl(value) {
    const url = new URL(value, window.location.href);
    return `${url.pathname}${url.search}${url.hash}`;
  }

  function sameOriginPageLink(link) {
    if (!link || !link.href || link.target && link.target !== "_self" || link.hasAttribute("download")) {
      return false;
    }
    const href = link.getAttribute("href");
    if (!href || href === "#" || href.startsWith("mailto:") || href.startsWith("tel:") || href.startsWith("javascript:")) {
      return false;
    }
    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin) return false;
    return !(url.pathname === window.location.pathname && url.search === window.location.search && url.hash !== window.location.hash);
  }

  function getCatalogState() {
    const state = readJson(catalogStateKey);
    if (!state) return null;
    if (state.updatedAt && Date.now() - state.updatedAt > 1000 * 60 * 60 * 24) return null;
    return state;
  }

  function setCatalogState(patch) {
    const next = {
      ...(getCatalogState() || {}),
      ...patch,
      updatedAt: Date.now()
    };
    writeJson(catalogStateKey, next);
    return next;
  }

  function getCatalogUrl(fallback = "/pages/all-products#catalog") {
    const state = getCatalogState();
    return state?.catalogUrl || fallback;
  }

  function runTransition(update) {
    if (!supportsViewTransitions) {
      update();
      return null;
    }
    return document.startViewTransition(() => Promise.resolve(update()));
  }

  function safeName(productId) {
    return String(productId || "").replace(/[^a-z0-9_-]/gi, "-");
  }

  function setProductTransitionNames(productId, refs = {}) {
    const suffix = safeName(productId);
    if (!suffix) return;
    if (refs.card) refs.card.style.viewTransitionName = `fastplus-card-${suffix}`;
    if (refs.image) refs.image.style.viewTransitionName = `fastplus-image-${suffix}`;
    if (refs.title) refs.title.style.viewTransitionName = `fastplus-title-${suffix}`;
  }

  function enhanceProductCard(card, productId, link) {
    if (!card || !productId) return;
    card.dataset.productId = productId;
    const image = card.querySelector("img");
    const title = card.querySelector(".product-title, .product-name, .finder-preview-name, strong");
    setProductTransitionNames(productId, { image, title });

    const targetLink = link || (card.matches("a[href]") ? card : card.querySelector("a[href]"));
    if (!targetLink) return;
    targetLink.addEventListener("click", () => {
      setCatalogState({
        productId,
        catalogUrl: relativeUrl(window.location.href),
        scrollY: window.scrollY
      });
    });
  }

  function applyReturnFocus(root = document) {
    const state = getCatalogState();
    if (!state?.productId) return null;
    const card = root.querySelector(`[data-product-id="${state.productId}"]`);
    if (!card) return state;
    card.classList.add("fastplus-return-focus");
    window.setTimeout(() => card.classList.remove("fastplus-return-focus"), 1200);
    return state;
  }

  document.addEventListener("click", (event) => {
    const link = event.target.closest("a[href]");
    if (!sameOriginPageLink(link)) return;
    document.documentElement.classList.add("is-route-transitioning");
  });

  window.addEventListener("pageshow", () => {
    document.documentElement.classList.remove("is-route-transitioning");
  });

  window.FastplusMotion = {
    applyReturnFocus,
    enhanceProductCard,
    getCatalogState,
    getCatalogUrl,
    relativeUrl,
    runTransition,
    setCatalogState,
    setProductTransitionNames,
    supportsViewTransitions
  };
})();
